"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Graph = /** @class */ (function () {
    function Graph(graph) {
        this.distance = {};
        this.pathLength = {};
        this.path = {};
        this.graph = graph;
        this.UnvisitAll();
    }
    Object.defineProperty(Graph.prototype, "length", {
        get: function () {
            return Object.keys(this.graph).length;
        },
        enumerable: false,
        configurable: true
    });
    Graph.prototype.UnvisitAll = function () {
        this.visited = {};
        // eslint-disable-next-line guard-for-in
        for (var key in this.graph) {
            this.visited[key] = false;
        }
    };
    Graph.prototype.AddEdge = function (key, value) {
        this.graph[key].push(value);
        this.graph[value].push(key);
    };
    Graph.prototype.DFSUtils = function (vertice, paths) {
        if (paths === void 0) { paths = []; }
        this.visited[vertice] = true;
        paths.push(vertice);
        for (var _i = 0, _a = this.graph[vertice]; _i < _a.length; _i++) {
            var neighbour = _a[_i];
            // eslint-disable-next-line no-param-reassign
            if (!this.visited[neighbour])
                paths = this.DFSUtils(neighbour, paths);
        }
        return paths;
    };
    Graph.prototype.AllPairShortestPath = function (_a) {
        var _b = _a.cache, cache = _b === void 0 ? false : _b;
        if (!cache) {
            this.distance = {};
            this.path = {};
        }
        else if (cache &&
            Object.keys(this.distance).length !== 0 &&
            Object.keys(this.path).length !== 0)
            return;
        // eslint-disable-next-line guard-for-in
        for (var vertice in this.graph) {
            this.distance[vertice] = {};
            this.path[vertice] = {};
            for (var neighbour in this.graph) {
                if (this.graph[vertice].includes(neighbour)) {
                    this.distance[vertice][neighbour] = 1;
                    this.path[vertice][neighbour] = neighbour;
                }
                else {
                    this.distance[vertice][neighbour] = Number.POSITIVE_INFINITY;
                }
            }
            this.distance[vertice][vertice] = 0;
            this.path[vertice][vertice] = vertice;
        }
        // eslint-disable-next-line guard-for-in
        for (var k in this.graph) {
            // eslint-disable-next-line guard-for-in
            for (var i in this.graph) {
                // eslint-disable-next-line guard-for-in
                for (var j in this.graph) {
                    var dist = this.distance[i][k] + this.distance[k][j];
                    if (this.distance[i][j] > dist) {
                        this.distance[i][j] = dist;
                        this.path[i][j] = this.path[i][k];
                    }
                }
            }
        }
        // eslint-disable-next-line guard-for-in
        for (var i in this.graph)
            for (var j in this.graph) {
                if (this.distance[i][j] === Number.POSITIVE_INFINITY)
                    delete this.distance[i][j];
            }
    };
    Graph.prototype.Path = function (source, dest) {
        if (this.path[source] == null || this.path[source][dest] == null)
            return [];
        var path = [];
        for (var node = source; node !== dest; node = this.path[node][dest]) {
            if (node == null) {
                return [];
            }
            path.push(node);
        }
        path.push(dest);
        return path;
    };
    Graph.prototype.PathLength = function (source, dest) {
        return this.Path(source, dest).length;
    };
    Graph.prototype.CalculateDistancesBetweenAllElements = function (_a) {
        var _b = _a.cache, cache = _b === void 0 ? false : _b;
        if (!cache)
            this.pathLength = {};
        else if (cache && Object.keys(this.pathLength).length > 0)
            return;
        this.AllPairShortestPath({ cache: true });
        // eslint-disable-next-line guard-for-in
        for (var i in this.path) {
            this.pathLength[i] = {};
            var sum = 0;
            var count = 0;
            // eslint-disable-next-line guard-for-in
            for (var j in this.path[i]) {
                var path = this.PathLength(i, j);
                this.pathLength[i][j] = path;
                sum += path;
                count += 1;
            }
            this.pathLength[i].count = sum / count;
        }
    };
    Graph.prototype.CalculateAverageDistanceBetweenAllElements = function () {
        var _this = this;
        this.CalculateDistancesBetweenAllElements({ cache: true });
        return Object.keys(this.pathLength)
            .sort(function (left, right) {
            return _this.pathLength[left].count - _this.pathLength[right].count;
        })
            .map(function (key) { return _this.pathLength[key]; });
    };
    Graph.prototype.ConnectedComponents = function () {
        this.UnvisitAll();
        var connections = [];
        for (var vertice in this.graph) {
            // eslint-disable-next-line no-param-reassign
            if (!this.visited[vertice]) {
                var curConnections = this.DFSUtils(vertice);
                connections.push(curConnections);
            }
        }
        return connections
            .sort(function (a, b) {
            return a.length < b.length ? 1 : -1;
        })
            .filter(function (connection) { return connection.length > 2; });
    };
    return Graph;
}());
exports.default = Graph;
//# sourceMappingURL=Graph.js.map